/**
 * - Pending State
 * - Fulfilled State
 * - Rejected State
 */

const count = false;
export let promise = new Promise(function (resolve, reject) {
	if (count) {
		resolve('there is count value');
	} else {
		// reject('there is no count value');
	}
});
